import type {TDevice} from "services-comun/modules/net/device";
import type {TSite} from "services-comun-meteored/modules/portal/tiempo";

export interface IConf {
    device: TDevice;
    lang: string;
    site: TSite;
}

declare var _mr_: IConf;

export default _mr_;
